/**
 * Builds thumbnail groups for the desktop product gallery strip.
 *
 * First and last groups hold up to 5 thumbs; middle groups hold 4 so the
 * prev/next chevrons can sit in the remaining slot.
 */
export const getThumbGroupCount = (thumbs: number): number[][] => {
    if (thumbs <= 0) {
        return [];
    }

    const remaining = Array.from({ length: thumbs }, (_, index) => index);
    const groups: number[][] = [];

    groups.push(remaining.splice(0, 5));

    while (remaining.length > 5) {
        groups.push(remaining.splice(0, 4));
    }

    if (remaining.length > 0) {
        groups.push(remaining);
    }

    return groups;
};

/**
 * 1-based thumb-group index that contains `slideIndex`, or `null` if none.
 */
export const resolveThumbGroupForSlide = (
    thumbGroups: number[][],
    slideIndex: number,
): number | null => {
    const groupIndex = thumbGroups.findIndex((group) =>
        group.includes(slideIndex),
    );
    return groupIndex >= 0 ? groupIndex + 1 : null;
};
